import { Injectable, Injector, OnDestroy } from '@angular/core';
import { CustomProduct } from '@product/const';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CatalogAnalyticsService } from '../../services';

/**
 * Абстрактный класс для имплементации аналитики в списки товаров
 *
 * Для использования необходимо создать дочерний класс с реализацией
 * метода установки наименования списка в зависимости от контекста
 * и наследоваться от ProductListAnalyticsService
 *
 * @example
 * @Injectable({ providedIn: 'root' })
 * export class ChildService extends ProductListAnalyticsService {
 *   setAnalyticsListName(): void {}
 * }
 *
 * Затем для списка товаров необходимо подменить ProductListAnalyticsService
 * на дочерний класс, так как плитка товара ожидает получить ProductListAnalyticsService
 *
 * @example
 * @Component({
 * selector: 'some-product-list',
 * providers: [
 *   ChildService,
 *   {
 *     provide: ProductListAnalyticsService,
 *     useExisting: ChildService,
 *   },
 *  ],
 * })
 *
 * В остальных же местах использовать ChildService для отправки событий.
 */
@Injectable()
export abstract class ProductListAnalyticsService implements OnDestroy {
  analyticsListName$ = new BehaviorSubject<string>('');

  protected subscription = new Subscription();
  private catalogAnalyticsService: CatalogAnalyticsService;

  constructor(injector: Injector) {
    this.catalogAnalyticsService = injector.get(CatalogAnalyticsService);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getListName(): string {
    return this.analyticsListName$.getValue();
  }

  /** Позиция товара в списке (0-based). Переопределяется в каруселях. */
  getProductIndex(productCode: string): number | undefined {
    void productCode;

    return undefined;
  }

  onViewProductList(products: CustomProduct[], offset?: number): void {
    const listName = this.analyticsListName$.getValue();

    if (!listName) {
      return;
    }

    this.catalogAnalyticsService.onViewProductList(products, listName, offset);
  }

  onClickProductInList(product: CustomProduct, index?: number): void {
    const listName = this.analyticsListName$.getValue();

    if (!listName) {
      return;
    }

    this.catalogAnalyticsService.onClickProductInList(product, listName, index);
  }
}
